import React from "react";
import { Phone, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="app-footer"
      className="w-full py-10 mt-16 text-center text-sm text-slate-500 border-t border-slate-100"
    >
      <p className="mb-2">
        © 2026 Valfrimobil Service. Alla rättigheter förbehållna.
      </p>
      <p className="mb-3 text-slate-400">Byggd av Valfrimobil</p>
      <div className="flex items-center justify-center gap-4 flex-wrap">
        <a
          data-testid="footer-phone-link"
          href="tel:0720080008"
          className="flex items-center gap-1.5 hover:text-[#3B9EDA] transition"
        >
          <Phone className="h-4 w-4" />
          0720080008
        </a>
        <span className="text-slate-300">|</span>
        <a
          data-testid="footer-email-link"
          href="mailto:molndal@valfrimobil.se"
          className="flex items-center gap-1.5 hover:text-[#3B9EDA] transition"
        >
          <Mail className="h-4 w-4" />
          molndal@valfrimobil.se
        </a>
      </div>
    </footer>
  );
};

export default Footer;
